import { ImageLoader } from "@src/helpers/ImageLoader";
import ImageResolution from "@src/saunaparts/ImageResolution";
import { LayerImageRepository, Sauna } from "..";

export class LowerBenchLightLayer
{
    imageRepository:LayerImageRepository;
    sauna:Sauna;
    constructor(imageRepository:LayerImageRepository,sauna:Sauna)
    {
        this.imageRepository= imageRepository;
        this.sauna=sauna;
    }
    Render(desiredResolution: ImageResolution,context:CanvasRenderingContext2D): Promise<CanvasRenderingContext2D> {
        
        
        let result :Promise<CanvasRenderingContext2D> | null = null;

        if(this.sauna.roofLight)
        {
            let roofLightPath = this.imageRepository.getRoofLigthLayer(this.sauna.Model,desiredResolution);
            result = new ImageLoader(roofLightPath).Load().then(i=>{
                context.globalCompositeOperation = "lighter";   
                context.drawImage(i,0,0,desiredResolution.width,desiredResolution.height);
                context.globalCompositeOperation= "source-over";
                return context;
            });
        }
        if(this.sauna.bottomBenchLight)
        {
            let bottomBenchLightPath = this.imageRepository.getLowerBenchinearBarLightLayer(this.sauna.Model,this.sauna.benchProductLine,desiredResolution);
            let loader = new ImageLoader(bottomBenchLightPath).Load().then(i=>{
                context.globalCompositeOperation = "lighter";      
                context.drawImage(i,0,0,desiredResolution.width,desiredResolution.height);
                context.globalCompositeOperation= "source-over";
                return context;
            });
            if(!result)
                {
                    result = loader;
                }
                else
                result = result.then(()=>loader);
        }
        if (!result) result = new Promise((resolve => resolve(context)))
        return result;

    }


}